import { createSelector } from '@reduxjs/toolkit';

import { applyDeclineRules } from '../rules';
import type { RootState } from '../store';
import { selectBusinessDetails, selectIsPropertyOwner } from './selectBusinessDetails';
import { selectIndustries } from './selectIndustries';

export const selectDecline = createSelector(
  selectBusinessDetails,
  selectIsPropertyOwner,
  selectIndustries,
  (state: RootState) => state.decline,
  (businessDetails, isPropertyOwner, industries, decline) => {
    if (businessDetails)
      return applyDeclineRules({
        businessDetails,
        decline,
        industries,
        isPropertyOwner,
      });
    return decline;
  }
);
